import React, { useState } from "react";
import SvgImage from "../../../Icons/Icons";
import { Modal, ModalBody, Button } from "reactstrap";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  addTripBulkExcelUpload,
  addTripBulkExcel,
  getTripsNew,
  addBulkTripIdExcelUpload,
  addBulkTripIdExcel,
  addDriverLedgerDownload,
  addDriverLedgerUploadExcel,
  clearDriverLedger,
  getDriverLedger,
} from "../../../../services/Store/Actions/TripsAction";
import {
  cleanWalletTransactionHistory,
  getWalletTransactionHistory,
} from "../../../../services/Store/Actions/walletAction";
import moment from "moment";
import { ClipLoader } from "react-spinners";

const AddBulkTripIdModal = (props) => {
  const {
    isOpen,
    onHide,
    handleClose,
    link,
    managerId,
    offsetMaster,
    check,
    start,
    end,
    driverLedger,
    userId,
  } = props;

  const [fileSave, setFileSave] = useState(null);
  const [fileName, setFileName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loader, setLoader] = useState(false);
  const [bulkTransfer, setBulkTransfer] = useState(false);
  const [openText, setOpenText] = useState(false);
  const dispatch = useDispatch();
  const customId2 = "custom-id-upload page";
  const notify2 = () =>
    toast.success("Template was downloaded successfully.", {
      toastId: customId2,
      pauseOnHover: false,
    });
  const customId3 = "custom-id-Salary-dispersed";
  const notify3 = () =>
    toast.success("Bulk Transactions Updated successfully", {
      toastId: customId3,
      pauseOnHover: false,
    });

  const downloadSalDisbursement = () => {
    setOpenText(!openText);
  };

  const uploadSheet = () => {
    // dispatch(
    //   addBulkTripIdExcelUpload({ NoRoute: route }, (res) => {
    //     console.log(res);
    //     setLoader(false);
    //     if (res.status == 200) {
    //       window.open(res.data?.data?.url);
    //       notify2();
    //       handleClose();
    //     } else {
    //       toast.error(res.data?.message || "some error occured");
    //       handleClose();
    //     }
    //   })
    // );
  };
  const downloadSheet = () => {
    console.log("startDate", startDate, endDate, driverLedger);
    setLoader(true);
    if (driverLedger) {
      dispatch(
        addDriverLedgerDownload(
          { startDate: startDate, endDate: endDate, userId: userId },
          (res) => {
            console.log("addDriverLedgerDownloadaddDriverLedgerDownload", res);
            setLoader(false);
            if (res.status == 200) {
              window.open(res.data?.data?.url);
              notify2();
              handleClose();
            } else {
              toast.error(res.data?.message || "some error occured");
              handleClose();
            }
          }
        )
      );
    } else {
      dispatch(
        addBulkTripIdExcel(
          { startDate: startDate, endDate: endDate },
          (res) => {
            console.log(res);
            setLoader(false);
            if (res.status == 200) {
              window.open(res.data?.data?.url);
              notify2();
              handleClose();
            } else {
              toast.error(res.data?.message || "some error occured");
              handleClose();
            }
          }
        )
      );
    }
  };

  const bulkTransferCall = () => {
    console.log("bulkTransferCallbulkTransferCall", fileSave);
    setLoader(true);
    if (driverLedger) {
      dispatch(
        addDriverLedgerUploadExcel({ file: fileSave }, (res) => {
          console.log("addDriverLedgerDownloadaddDriverLedgerDownload", res);
          setLoader(false);
          if (res.status == 200) {
            dispatch(clearDriverLedger());
            let id = userId;
            dispatch(
              getDriverLedger(
                id,
                {
                  offset: 0,
                  limit: 10,
                },
                () => {}
              )
            );
            notify3();
            handleClose();
          } else {
            toast.error(res.data?.message || "some error occured");
            handleClose();
          }
        })
      );
    } else {
      dispatch(
        addBulkTripIdExcelUpload({ file: fileSave }, (res) => {
          console.log(res);
          setLoader(false);
          if (res.status == 200) {
            notify3();
            handleClose();
            dispatch(cleanWalletTransactionHistory());
            if (check) {
              dispatch(
                getWalletTransactionHistory({
                  offset: offsetMaster,
                  limit: "",
                  from: moment(start).format("YYYY-MM-DD"),
                  to: moment(end).format("YYYY-MM-DD"),
                  userId: managerId,
                })
              );
            } else
              dispatch(
                getWalletTransactionHistory({
                  offset: offsetMaster,
                  limit: "",
                  from: "",
                  to: "",
                  userId: managerId,
                })
              );
          } else {
            toast.error(res.data?.message || "some error occured");
            handleClose();
          }
        })
      );
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      onHide={onHide}
      className=" modal-dialog-centered modal-dialog model-width-toast"
      aria-labelledby="myModalLabel2"
    >
      <ModalBody>
        <div style={{ width: "auto" }}>
          <div>
            <div className=/*"PGCollectionclose */ "closeEffectRow close-btn-for-transaction">
              <div
                className="closeEffect"
                style={{ right: 0 }}
                onClick={handleClose}
              >
                <SvgImage
                  classname="close-btn-text"
                  style={{ width: "10%", height: "10%" }}
                  name="CloseButtonLogo"
                  width="20%"
                  height="20%"
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                marginTop: "-10px",
              }}
            ></div>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div
                className="col-lg-6"
                style={{ padding: "10px" }}
                onClick={downloadSalDisbursement}
              >
                <div
                  className="svgContainerUp"
                  style={{ margin: "0 23px", textAlign: "center" }}
                >
                  <SvgImage name="Download" />
                </div>
                <div className="Bold300" style={{ textAlign: "center" }}>
                  Download Template
                </div>
              </div>
              <div className="col-lg-6" style={{ padding: "10px" }}>
                <label for="file-upload2" class="custom-file-upload3">
                  <input
                    id="file-upload2"
                    type="file"
                    onChange={async (e) => {
                      const img = e?.target.files[0];
                      setFileName(img?.name);
                      setFileSave(img);
                      //   console.log("image", img);
                      setOpenText(false);
                      setBulkTransfer(1);
                      // notify2();
                    }}
                  />
                  <div
                    className="svgContainerUp"
                    style={{
                      margin: "0px 23px",
                      backgroundColor: bulkTransfer > 0 ? "antiquewhite" : null,
                      textAlign: "center",
                    }}
                  >
                    <SvgImage name="Upload" />
                  </div>
                  <div className="Bold300" style={{ textAlign: "center" }}>
                    Upload for bulk Update
                  </div>
                </label>
              </div>
            </div>
          </div>
          {openText ? (
            <div>
              <div className="d-flex justify-content-around">
                <div>
                  <div>Start Date</div>
                  <div>
                    <input
                      type="date"
                      value={startDate}
                      onChange={(e) => {
                        console.log("kklllllll", e?.target?.value);
                        setStartDate(e?.target?.value);
                      }}
                    />
                  </div>
                </div>
                <div>
                  <div>End Date</div>
                  <div>
                    <input
                      type="date"
                      value={endDate}
                      onChange={(e) => {
                        console.log("kklllllll", e?.target?.value);
                        setEndDate(e?.target?.value);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div style={{ marginTop: "12px", textAlign: "center" }}>
                <button onClick={downloadSheet} type="submit">
                  {" "}
                  submit
                </button>
              </div>
            </div>
          ) : bulkTransfer ? (
            <div className="row">
              <div className="col-8">{fileName}</div>
              <div style={{ textAlign: "center" }} className="col-4">
                <button type="submit" onClick={bulkTransferCall}>
                  {" "}
                  submit
                </button>
                {loader ? (
                  <ClipLoader
                    color={"#485B7C"}
                    loading={true}
                    size={20}
                    aria-label="Loading Spinner"
                    data-testid="loader"
                  />
                ) : null}
              </div>
            </div>
          ) : (
            <></>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default AddBulkTripIdModal;
